/* eslint-disable */
import { SET_DATA, DELETE_DATA, DELETE_INDEX } from '../actions/action.constants';
import * as _ from 'lodash';

export default function applicationStore(state = {}, action) {
  switch (action.type) {
    case SET_DATA:
      return _.merge({}, state, _.set({}, action.path, action.value));

    case DELETE_DATA:
      let delObj = _.merge({}, state);
      _.unset(delObj, action.path);
      return delObj;

    case DELETE_INDEX:
      const indexObj = _.merge({}, state);
      _.get(indexObj, action.path).splice(action.index, 1);
      return indexObj;

    default:
      return state;
  }
}
